import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Paragraph, Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import DropdownIcon from 'components/svg/Dropdown';

import './FeeWarningToolTip.scss';

export function FeeWarningToolTip({ facility, className }) {
	const fees = [
		{ name: 'One-Time Admin Fee', price: facility.adminFee },
		{ name: 'One-Time Lock Fee', price: facility.lockFee },
	];
	const totalFees = facility.totalFees;
	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={
				<Paragraph
					size="tiny"
					color="gray"
				>
					The following fees shall apply:
					<ul>
						{fees.map(
							(fee) =>
								fee.price > 0 && (
									<li
										key={fee.name}
										className="fee-item"
									>
										{`${fee.name}: $${fee.price}`}
									</li>
								),
						)}
					</ul>
				</Paragraph>
			}
		>
			<Text
				last
				size="tiny"
				color="gray"
			>
				+ ${totalFees} in fees
				<DropdownIcon />
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTip.propTypes = {
	facility: PropTypes.shape({
		adminFee: PropTypes.number,
		lockFee: PropTypes.number,
		totalFees: PropTypes.number,
	}).isRequired,
	className: PropTypes.string,
};

export default FeeWarningToolTip;
